/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';

export const certificationSchema: z.AnyZodObject = z.object({
  award: z.string().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  institution: z.string().nullish(),
  stateExamScore: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  year: z.number().int().nullish(),
});

export type Certification = z.infer<typeof certificationSchema>;
